import React, { useContext, useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import {
  Avatar,
  IconButton,
  Button,
  Stack,
  Toolbar,
  Box,
  Typography,
  Tooltip,
  Menu,
  MenuItem,
} from "@mui/material";
//Icons
import logo from "../Assets/it-logo.png";
import CamFlag from "../Assets/Cambodia.png";
import EngFlag from "../Assets/United_Kingdom.png";
import DashboardIcon from "@mui/icons-material/Dashboard";
import { FaComputer } from "react-icons/fa6";
import { GiTakeMyMoney } from "react-icons/gi";
import DescriptionIcon from "@mui/icons-material/Description";
import AssessmentIcon from "@mui/icons-material/Assessment";
import WarehouseIcon from "@mui/icons-material/Warehouse";
import SettingsIcon from "@mui/icons-material/Settings";
import { FaShop } from "react-icons/fa6";
import { HiUserGroup } from "react-icons/hi2";
import { RiUserFollowFill } from "react-icons/ri";
import { BiSolidReport } from "react-icons/bi";

import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
//Srcs
import "./topnavbar.scss";
import { AuthContext } from "../Context/AuthContext";
import { translateLauguage } from "../Function/Translate";
import { LogoutDialog } from "./LogoutDialog";

import schoolLogo from "../Assets/favicon.ico";
// import schoolLogo from "../Assets/pepy-logo.jpg"

export default function TopNavbar() {
  const navigate = useNavigate();
  const location = useLocation();

  let userLogin = JSON.parse(window.localStorage.getItem("logIn"));

  // console.log("userLoginTopNavbar::::", userLogin);

  // ===================== Change Language ==========================
  const { language, setAlert, dispatch, role, changeLanguage } =
    useContext(AuthContext);
  const { t } = translateLauguage(language);

  // ============================ Resize width ============================
  const fixwith = 1370;
  const [width, setWidth] = useState(window.innerWidth);
  const updateDimensions = () => {
    setWidth(window.innerWidth);
  };
  useEffect(() => {
    window.addEventListener("resize", updateDimensions);
    return () => window.removeEventListener("resize", updateDimensions);
  }, []);

  // ======================= Change language function =======================
  const [langauge, setLanguage] = useState(
    JSON.parse(window.localStorage.getItem("language"))
  );
  const handleChangeLanguage = (lang) => {
    window.localStorage.setItem("language", JSON.stringify(lang));
    setLanguage(lang);
    changeLanguage(lang);
  };

  useEffect(() => {
    async function checkLanguage() {
      let userLanguage = await JSON.parse(
        window.localStorage.getItem("language")
      );
      if (userLanguage) {
        setLanguage(userLanguage);
        return;
      } else {
        setLanguage("kh");
      }
    }
    checkLanguage();
  }, []);

  // ============== log out ============
  // ================== Function menu logout ===================
  const [anchorEl, setAnchorEl] = useState(null);
  const openMenu = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // ================== Function open logout ===================
  const [oepnLogout, setOpenLogout] = useState(false);
  const handleOpenLogout = () => {
    setOpenLogout(true);
    handleClose();
  };
  const handleCloseLogout = () => {
    setOpenLogout(false);
  };

  //======================= List Menu ====================
  const listMenu = userLogin?.role === "Teacher" ?
    [
      {
        title: t(`page-dashboard`),
        active: location?.pathname === "/dashboard" ? true : false,
        navigate: "/dashboard",
        icon: <DashboardIcon className="link-icon" />,
      },
      {
        title: t(`page-student`),
        active:
          location?.pathname === "/student" ||
            location?.pathname === "/student/student-detail"
            ? true
            : false,
        navigate: "/student",
        icon: <HiUserGroup className="link-icon" />,
      },
      {
        title: t(`page-attendance`),
        active:
          location?.pathname === "/attendance" ||
            location?.pathname === "/attendance/attendance-check"
            ? true
            : false,
        navigate: "/attendance",
        icon: <RiUserFollowFill className="link-icon" />,
      },


    ].filter(Boolean) : [
      {
        title: t(`page-dashboard`),
        active: location?.pathname === "/dashboard" ? true : false,
        navigate: "/dashboard",
        icon: <DashboardIcon className="link-icon" />,
      },
      {
        title: t(`page-student`),
        active:
          location?.pathname === "/student" ||
            location?.pathname === "/student/student-detail"
            ? true
            : false,
        navigate: "/student",
        icon: <HiUserGroup className="link-icon" />,
      },
      {
        title: t(`page-attendance`),
        active:
          location?.pathname === "/attendance" ||
            location?.pathname === "/attendance/attendance-check"
            ? true
            : false,
        navigate: "/attendance",
        icon: <RiUserFollowFill className="link-icon" />,
      },

      {
        title: t(`page-report`),
        active: location?.pathname === "/report" ? true : false,
        navigate: "/report",
        icon: <BiSolidReport className="link-icon-a" />,
      },
      {
        title: t(`page-setting`),
        active:
          location?.pathname === "/setting" ||
            location?.pathname === "/setting/user" ||
            location?.pathname === "/setting/academic-year" ||
            location?.pathname === "/setting/school" ||
            location?.pathname === "/setting/level" ||
            location?.pathname === "/setting/class" ||
            location?.pathname === "/setting/group"
            ? true
            : false,
        navigate: "/setting",
        icon: <SettingsIcon className="link-icon-a" />,
      },
    ].filter(Boolean)



  return (
    <Toolbar className="top-navbar-style">
      <Stack direction="row" spacing={4} sx={{ width: "100%", height: "100%" }}>
        <IconButton onClick={() => navigate("/dashboard")}>
          <Stack
            direction={`row`}
            spacing={2}
            className="logo-container"
            justifyContent={`center`}
            alignItems={`center`}
          >
            <img src={schoolLogo} alt="schoolLogo" className="logo-style" />
          </Stack>
        </IconButton>

        {/* ================================== Menu Item ========================================= */}
        <Stack direction="row" spacing={0} sx={{ height: "100%" }}>
          {listMenu?.map((listItem, index) => (
            <Tooltip title={listItem?.title} arrow key={index}>
              <Button
                className={listItem?.active ? "list-item-active" : "list-item"}
                onClick={() => navigate(`${listItem?.navigate}`)}
              >
                <Stack direction="row" spacing={1}>
                  {/* <Stack direction="column" justifyContent="center"> */}
                  {listItem?.icon}
                  {/* </Stack> */}
                  {width > fixwith ? (
                    <Stack direction="column" justifyContent="center">
                      <Typography
                        className={
                          language === "kh" ? "icon-title-kh" : "icon-title"
                        }
                      >
                        {listItem?.title}
                      </Typography>
                    </Stack>
                  ) : null}
                </Stack>
              </Button>
            </Tooltip>
          ))}
        </Stack>
        {/* ======== End  Menu Item ============ */}

        <Box sx={{ flexGrow: 1 }} />

        <Stack
          direction="row"
          spacing={2}
          justifyContent="right"
          alignContent={`center`}
        >
          <Stack direction="column" justifyContent="center">
            {langauge === "en" ? (
              <Tooltip title="Change to Khmer" placement="left">
                <IconButton onClick={() => handleChangeLanguage("kh")}>
                  <Avatar
                    src={EngFlag}
                    sx={{ width: "30px", height: "30px" }}
                  />
                </IconButton>
              </Tooltip>
            ) : (
              <Tooltip title="Change to English" placement="left">
                <IconButton onClick={() => handleChangeLanguage("en")}>
                  <Avatar
                    src={CamFlag}
                    sx={{ width: "30px", height: "30px" }}
                  />
                </IconButton>
              </Tooltip>
            )}
          </Stack>

          <Stack direction="column" justifyContent="center">
            <Button className="btn-menu" onClick={handleClick}>
              <Stack direction="row" spacing={2}>
                <Stack direction="column" textAlign="left">
                  <Typography
                    className={
                      language === "en" ? "username-text" : "username-text-kh"
                    }
                  >
                    {userLogin
                      ? langauge === "en"
                        ? userLogin?.latin_name
                        : userLogin?.last_name + " " + userLogin?.first_name
                      : "NO User"}
                  </Typography>
                  <Typography
                    className={language === "en" ? "role-text" : "role-text-kh"}
                  >
                    {userLogin ? userLogin?.role : "NO Role"}
                  </Typography>
                </Stack>
                <Stack direction="column" justifyContent="center">
                  {openMenu ? (
                    <ArrowDropUpIcon className="icon-menu" />
                  ) : (
                    <ArrowDropDownIcon className="icon-menu" />
                  )}
                </Stack>
              </Stack>
            </Button>

            <Menu
              anchorEl={anchorEl}
              id="account-menu"
              open={openMenu}
              onClose={handleClose}
              onClick={handleClose}
              // PaperProps={{
              //   elevation: 0,
              //   sx: {
              //     overflow: "visible",
              //     filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
              //     mt: 1.5,
              //     "& .MuiAvatar-root": {
              //       width: 32,
              //       height: 32,
              //       ml: -0.5,
              //       mr: 1,
              //     },
              //     "&:before": {
              //       content: '""',
              //       display: "block",
              //       position: "absolute",
              //       top: 0,
              //       right: 14,
              //       width: 10,
              //       height: 10,
              //       bgcolor: "background.paper",
              //       transform: "translateY(-50%) rotate(45deg)",
              //       zIndex: 0,
              //     },
              //   },
              // }}
              transformOrigin={{ horizontal: "right", vertical: "top" }}
              anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
            >
              <MenuItem onClick={handleOpenLogout}>
                <Typography className="log-out-txt">{t("log_out")}</Typography>
              </MenuItem>
            </Menu>

            <LogoutDialog open={oepnLogout} handleClose={handleCloseLogout} />
          </Stack>
        </Stack>
      </Stack>
    </Toolbar>
  );
}
